import { useSearchParams, useNavigate } from "react-router-dom";
import { decrypt } from "@/utils/ogeDecrypt";
import { useDispatch } from "react-redux";
import { setIsOpen, setUserInfo, setAvatar } from "@/store/modules/user";
import { login, userDetail } from "@/apis/user";
import { encrypt } from "@/utils/jsencrypt";
import { useEffect } from "react";
function getUrlParams() {
	const url = window.location.href;
	const regex = /[?&]([^=#]+)=([^&#]*)/g;
	let params = {};
	let match;
	while ((match = regex.exec(url))) {
	  params[decodeURIComponent(match[1])] = decodeURIComponent(match[2]);
	}
	return params;
  }
const BlankPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {url,p,u} = getUrlParams();
  const userName = u;
  const password = p;
  useEffect(() => {
    if (userName && password) {
      login({
        username: userName,
        password: encrypt(decrypt(password)),
        userSource: "oge",
      })
        .then((res) => {
          dispatch(setIsOpen(false));
          dispatch(
            setUserInfo({
              token: res.data.token,
              refreshToken: res.data.refreshToken,
            })
          );
          userDetail().then((result) => {
            dispatch(
              setUserInfo({
                email: result.data.email,
                username: result.data.username,
				        nickname:result.data.nickname,
				        uuid:result.data.uuid,
                token: res.data.token,
                refreshToken: res.data.refreshToken,
                roleId: result.data?.role?.roleId,
                password: password,
              })
            );
            dispatch(setAvatar(result.data?.avatar?.filePath));
          });

          navigate("/" + url);
        })
        .catch((err) => {});
    }
  }, [userName, password]);
  return <div></div>;
};
export default BlankPage;
